import PropTypes from "prop-types";
import { Button, Select, SettingsCard } from "top-component-library";
import { FormRow, SettingHint } from "../styles";

// Mirrors editCustomerProperties.html's "Restaurant Brand Chain Config" card
// (Customer.brand_parent/brand_children - a plain self-referential relation, distinct from
// chain_parent/chain_children which nothing on this page touches).
const BrandChainConfigCard = ({
  customerId,
  brandChildren,
  allowedCustomers,
  changed,
  saving,
  onAddBrandChild,
  onRemoveBrandChild,
  onSave,
}) => {
  const addedChildIds = brandChildren.map((child) => child.customer_id);
  const selectableCustomers = allowedCustomers.filter(
    (option) => option.customer_id !== customerId && !addedChildIds.includes(option.customer_id)
  );

  return (
    <SettingsCard title="Restaurant Brand Chain Config">
      <SettingHint>
        You can set this account to control the brand assets for another account. This includes the business name shown
        on the Branded Ordering Site landing page and the logo displayed there.
      </SettingHint>
      {brandChildren.map((child) => (
        <FormRow key={child.customer_id}>
          <label>{child.name_for_admin}</label>
          <Button danger onClick={() => onRemoveBrandChild(child.customer_id)}>
            Remove
          </Button>
        </FormRow>
      ))}
      <FormRow>
        <label htmlFor="customer-properties-add-brand-child">Add Brand Child</label>
        <Select
          id="customer-properties-add-brand-child"
          value={undefined}
          onChange={(customerIdToAdd) =>
            onAddBrandChild(selectableCustomers.find((option) => option.customer_id === customerIdToAdd))
          }
        >
          {selectableCustomers.map((option) => (
            <Select.Option key={option.customer_id} value={option.customer_id}>
              {option.name_for_admin}
            </Select.Option>
          ))}
        </Select>
      </FormRow>
      <Button type="primary" loading={saving} disabled={!changed} onClick={onSave}>
        Save Brand Children
      </Button>
    </SettingsCard>
  );
};

BrandChainConfigCard.propTypes = {
  customerId: PropTypes.string,
  brandChildren: PropTypes.arrayOf(
    PropTypes.shape({ customer_id: PropTypes.string.isRequired, name_for_admin: PropTypes.string.isRequired })
  ).isRequired,
  allowedCustomers: PropTypes.arrayOf(
    PropTypes.shape({ customer_id: PropTypes.string.isRequired, name_for_admin: PropTypes.string.isRequired })
  ).isRequired,
  changed: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  onAddBrandChild: PropTypes.func.isRequired,
  onRemoveBrandChild: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

BrandChainConfigCard.defaultProps = {
  customerId: undefined,
};

export default BrandChainConfigCard;
